import * as Yup from 'yup';
import moment from 'moment';
import { t } from 'i18next';

function isEndingAfterStart(value) {
    const { start_date, start_time, ending_time, isActive } = this.parent;
    if (!value || !moment(value).isValid()) return true;

    const endDate = moment(value).startOf('day');
    const startDate = isActive
        ? moment().startOf('day')
        : start_date && moment(start_date).isValid()
          ? moment(start_date).startOf('day')
          : null;
    if (!startDate) return true;
    if (endDate.isBefore(startDate)) return false;
    if (!endDate.isSame(startDate)) return true;

    if (!ending_time || !moment(ending_time).isValid()) return true;

    const endDateTime = moment(value)
        .hour(moment(ending_time).hour())
        .minute(moment(ending_time).minute())
        .second(moment(ending_time).second())
        .millisecond(0);

    if (isActive) {
        return endDateTime.isAfter(moment());
    }
    if (!start_time || !moment(start_time).isValid()) return true;

    const startDateTime = moment(start_date)
        .hour(moment(start_time).hour())
        .minute(moment(start_time).minute())
        .second(moment(start_time).second())
        .millisecond(0);

    return endDateTime.isAfter(startDateTime);
}

export function getOfferScheduleValidationFields() {
    return {
        isActive: Yup.boolean(),
        start_date: Yup.date()
            .nullable()
            .when('isActive', {
                is: false,
                then: Yup.date()
                    .required(t('SpOffers.YupErrStartDateRequired'))
                    .nullable()
                    .typeError(t('SpOffers.YupErrStartDateTypeError')),
                otherwise: Yup.date().nullable(),
            }),
        start_time: Yup.string().when('isActive', {
            is: false,
            then: Yup.string().required(t('SpOffers.YupErrStartTimeRequired')).nullable(),
            otherwise: Yup.string().nullable(),
        }),
        ending_date: Yup.date()
            .nullable()
            .required(t('SpOffers.YupErrEndingDateRequired'))
            .typeError(t('SpOffers.YupErrEndingDateTypeError'))
            .when(['isActive', 'start_date', 'start_time', 'ending_time'], {
                is: () => true,
                then: (schema) =>
                    schema.test('isAfterStartDate', t('SpOffers.YupErrEndingDateAfterStart'), isEndingAfterStart),
            }),
        ending_time: Yup.string().when('isActive', {
            is: false,
            then: Yup.string().required(t('SpOffers.YupErrEndingTimeRequired')).nullable(),
            otherwise: Yup.string().required(t('SpOffers.YupErrEndingTimeRequired')).nullable(),
        }),
    };
}
